import { useLingui } from '@lingui/react/macro';
import type { FC } from 'react';
import { cn } from '@/shared/react';
import bearishIcon from '../../assets/Bearish.svg';
import bullishIcon from '../../assets/Bullish.svg';

type VoteButtonProps = {
  variant: 'bullish' | 'bearish';
  onClick: () => void;
  isActive: boolean;
  disabled: boolean;
};

export const VoteButton: FC<VoteButtonProps> = ({
  variant,
  onClick,
  isActive,
  disabled,
}) => {
  const { t } = useLingui();
  const isBullish = variant === 'bullish';

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'py-3 w-full px-8 cursor-pointer disabled:cursor-default',
        'transition-transform duration-75 ease-out',
        isBullish
          ? [
              'bg-content-positive text-content-primary-inverse',
              '!rounded-tl-full !rounded-bl-full !rounded-tr-full !rounded-b-lg',
              'shadow-[0_6px_0_0_#008e75]',
              'active:translate-y-[6px] active:shadow-[0_0_0_0_#008e75]',
              'disabled:translate-y-[6px] disabled:shadow-[0_0_0_0_#008e75]',
              !isActive && 'bg-content-positive/50',
            ]
          : [
              'bg-content-negative text-content-primary-inverse',
              '!rounded-tr-full !rounded-br-full !rounded-tl-lg !rounded-bl-full',
              'shadow-[0_6px_0_0_#ba1944]',
              'active:translate-y-[6px] active:shadow-[0_0_0_0_#ba1944]',
              'disabled:translate-y-[6px] disabled:shadow-[0_0_0_0_#ba1944]',
              !isActive && 'bg-content-negative/50',
            ],
      )}
    >
      <span className="flex items-center justify-center gap-2">
        <img
          src={isBullish ? bullishIcon : bearishIcon}
          alt={isBullish ? 'Up Icon' : 'Down Icon'}
          className="h-5 w-5"
        />
        {isBullish ? t`Bullish` : t`Bearish`}
      </span>
    </button>
  );
};
